import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import {
  updateScheduleForm as onUpdate,
  updateTimeSlot as onTimeSlotUpdate,
  removeTimeSlot as onTimeSlotRemove,
  addTimeSlot as onTimeSlotAdd,
  resetScheduleForm,
} from '../../actions/scheduleForm';

import { createSchedule } from '../../actions/events';

import Window from '../layout/Window';
import Button from '../layout/Button';
import Loading from '../layout/Loading';
import Form from '../forms/Schedule';
import './new.scss';

class New extends Component {
  constructor(props) {
    super(props);
    this.onCreateClick = this.onCreateClick.bind(this);
  }
  componentWillUnmount() {
    this.props.resetScheduleForm();
  }

  onCreateClick() {
    const { createSchedule, schedule, organisationId, eventId, history, location } = this.props;
    createSchedule(eventId, schedule).then(({ value }) => {
      history.push(`/organisations/${organisationId}/events/${eventId}/schedules/${value.id}${location.search}`)
    })
  }

  render() {
    const { t, organisationId, eventId, history, location, loading, schedule, ...rest } = this.props;

    return (
      <Window
        onCloseClick={() => history.push(`/organisations/${organisationId}/events/${eventId}/schedules${location.search}`)}
        title={"New event schedule"}>
          {loading && <Loading />}
          <Form schedule={schedule} { ...rest } />
          <Button className="save-new-profile" onClick={this.onCreateClick}>{t('SAVE_NEW_SCHEDULE')}</Button>
      </Window>
    );
  }
}

export default translate('profile')(withRouter(connect(
  ( { ui: { scheduleForm } }, { match: { params: { organisationId, eventId } }, location, history }) => ({
    organisationId,
    eventId,
    location,
    history,
    schedule: scheduleForm.schedule,
    loading: scheduleForm.posting,
  }), {
    onUpdate,
    onTimeSlotUpdate,
    onTimeSlotRemove,
    onTimeSlotAdd,
    resetScheduleForm,
    createSchedule
  }
)(New)));



// WEBPACK FOOTER //
// ./src/components/schedules/New.js